document.addEventListener("DOMContentLoaded", function () {
    const descriptionContainer = document.querySelector("body.product .product__description");
    if (!descriptionContainer) return;
    const originalContent = descriptionContainer.innerHTML.trim(),
        maxLength = 600;
    if (originalContent.length > maxLength) {
        const shortContent = originalContent.substring(0, maxLength) + "...";
        (descriptionContainer.innerHTML = `
            <div class="short-description">${shortContent}</div>
            <button class="read-more-btn">Read More</button>
        `),
            document.querySelector(".read-more-btn").addEventListener("click", function () {
                this.textContent === "Read More"
                    ? (descriptionContainer.innerHTML = `
                    <div class="full-description">${originalContent}</div>
                    <button class="read-more-btn">Read Less</button>
                `)
                    : (descriptionContainer.innerHTML = `
                    <div class="short-description">${shortContent}</div>
                    <button class="read-more-btn">Read More</button>
                `),
                    document.querySelector(".read-more-btn").addEventListener("click", arguments.callee);
            });
    }
}),
    document.addEventListener("DOMContentLoaded", function () {
        document.querySelector(".rev_btn_on").addEventListener("click", function () {
            setTimeout(function () {
                var reviewWidget = document.querySelector(".shopify-block.shopify-app-block #judgeme_product_reviews"),
                    targetDiv = document.querySelector("#tab-3");
                reviewWidget && targetDiv && targetDiv.appendChild(reviewWidget);
            }, 10);
        });
    }),
    document.addEventListener("DOMContentLoaded", function () {
 document.querySelectorAll(".custom_tabs ul.tabs").forEach(function (tabContainer) {
  let links = tabContainer.querySelectorAll("a"),
      active = links[0],
      content = document.querySelector(active.getAttribute("href"));

  active.classList.add("active");

  links.forEach(function (link, index) {
    let tabContent = document.querySelector(link.getAttribute("href"));
    if (tabContent) {
      if (index !== 0) {
        tabContent.style.display = "none";
      }

      // 👇 Mobile View: Move tab content after its corresponding link
      if (window.innerWidth <= 768) {
        link.insertAdjacentElement("afterend", tabContent);
      }
    }
  });

  links.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      let targetContent = document.querySelector(this.getAttribute("href"));

      // if (window.innerWidth <= 768) {
        // 📱 Mobile toggle
        if (this.classList.contains("active")) {
          // agar already active h to remove + hide
          this.classList.remove("active");
          if (targetContent) targetContent.style.display = "none";
          active = null;
          content = null;
          return;
        }
      // }

      // 💻 Desktop (or switching to another tab)
      if (active) active.classList.remove("active");
      if (content) content.style.display = "none";

      active = this;
      content = targetContent;

      if (active) active.classList.add("active");
      if (content) content.style.display = "block";
    });
  });
});
});



function moveQtyElement() {
  var qty = document.querySelector(".product-form__input.product-form__quantity");
  var targetDesktop = document.querySelector(".wrappar-with-qty");
  var targetMobile = document.querySelector(".price-wraper");

  if (!qty || (!targetDesktop && !targetMobile)) return;

  if (window.innerWidth > 768) {
    if (targetDesktop && !targetDesktop.contains(qty)) {
      targetDesktop.appendChild(qty);
      // console.log("hi test fix qty");
    }
  } else {
    if (targetMobile && !targetMobile.contains(qty)) {
      targetMobile.appendChild(qty);
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(moveQtyElement, 300);
  moveQtyElement();
});

window.addEventListener("resize", moveQtyElement);

(function () {
  const observer = new MutationObserver(moveQtyElement);
  observer.observe(document.body, { childList: true, subtree: true });
})();




